module.exports = __webpack_public_path__ + "static/media/cq_editor_testo_destra.0f571979.svg";